import { render, staticRenderFns } from "./promotion-detail.vue?vue&type=template&id=0f7e5df8&scoped=true&"
import script from "./promotion-detail.vue?vue&type=script&lang=js&"
export * from "./promotion-detail.vue?vue&type=script&lang=js&"
import style0 from "./promotion-detail.vue?vue&type=style&index=0&id=0f7e5df8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f7e5df8",
  null
  
)

export default component.exports